export enum ShouldShowModal {
  CHECk_EMAIL,
  CONFIRM_EMAIL,
  // PERSONAL_DATA,
  TERMS,
  LOGIN,
  ADDRESS,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_BIOMETRIC_FACE,
  FORGOT_PASSWORD_BIOMETRIC,
  CHECk_EMAIL_FORGOT_PASSWORD,
  CONFIRM_EMAIL_FORGOT_PASSWORD,
  CHANGE_CLIENT_DATA,
  CALL_CHANGE_PASSWORD,
  CHANGE_PASSWORD,
  CONFIRM_REGISTER,
  LOGOUT,
  BIOMETRIC_FACE,
  BIOMETRIC_FACE_CHECK,
  CHECK_ACCOUNT_CONTENT,
}

export type ShouldShowModalProps = {
  value: ShouldShowModal;
  newTitle: string | React.ReactNode;
};

export enum FormInputNameCheckEmail {
  cpf = 'cpf',
  email = 'email',
  name = 'name',
  phone = 'phone',
}

export enum FormInputCheck {
  cpf = 'cpf',
  faceId = 'faceId',
  name = 'name',
}

export enum FormInputNameConfirmEmail {
  cpf = 'cpf',
  email = 'email',
  phone = 'phone',
  confirmationCode = 'confirmationCode',
}

export enum FormInputNameRegister {
  name = 'name',
  document = 'document',
  email = 'email',
  confirmationCode = 'confirmationCode',
  phone = 'phone',
  date = 'date',
  motherName = 'motherName',
  password = 'password',
  confirmPassword = 'confirmPassword',
  terms = 'terms',
  zipCode = 'zipCode',
  state = 'state',
  city = 'city',
  district = 'district',
  street = 'street',
  complement = 'complement',
  addressnumber = 'addressnumber',
}

export enum FormInputNameLogin {
  document = 'document',
  password = 'password',
}

export enum FormInputNameChangeClientData {
  document = 'document',
  name = 'name',
  email = 'email',
  phone = 'phone',
  date = 'date',
  motherName = 'motherName',
}

export enum FormInputNameAddress {
  zipCode = 'zipCode',
  state = 'state',
  city = 'city',
  district = 'district',
  street = 'street',
  complement = 'complement',
  addressnumber = 'addressnumber',
}

export enum FormInputNameContacts {
  name = 'name',
  email = 'email',
  message = 'message',
}

export enum FormInputNameRegisterConfirm {
  code = 'code',
}

export interface NavigationMenu {
  name: string;
  href: string;
  current: boolean;
}

export interface FirstLogin {
  cpf: string;
  password: string;
}
